/* global axios */
import ApiClient from './ApiClient';

class WorkflowFieldTemplatesAPI extends ApiClient {
  constructor() {
    super('workflow_field_templates', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }
}

export default new WorkflowFieldTemplatesAPI();
